import React from "react";

export default function DocImg(props) {
  var {img, title, className, width } = props
  return <>
    <a href={img} target="_blank" rel="noreferrer" title="open image in a new tab"><img src={img} alt={title} title={title} className={className} width={width} /></a>
  </>
}
